
import { getRecentLiquidDeliveries } from "../../../../services/requests/billing/liquid-billing-requests";
import { DataSource } from "../../../UI/view/data-source";
import { ListView, ListViewColumnType, initListView } from "../../../UI/view/list-view";

export const recentDeliveriesDataSource = {
  name: 'recentLiquidDeliveries',
  pk: 'billingId',
  request: getRecentLiquidDeliveries,
  requestArgs: (state) => {
    return state.liquidbilling.current?.data?.customerId;
  }
} as DataSource;

export const recentDeliveries = {
  columns: [
    {
      Header: 'Date Shipped',
      accessor: 'dateShipped',
      type: ListViewColumnType.date,
      defaultSort: true
    },
    {
      Header: 'Volume Delivered',
      accessor: 'jdeVolume'
    },
  ]
} as ListView;

export const RecentDeliveriesList = initListView(recentDeliveries, recentDeliveriesDataSource);